// extracted by mini-css-extract-plugin
export default {"app":"FormBuilder_app__rh-gc","main":"FormBuilder_main__Hz32g","body":"FormBuilder_body__jJJc+"};